import React from "react"
import type { ReactNode } from "react"

export type VisuallyHiddenProps = {
  /** Content that is visually hidden but remains accessible to screen readers */
  children: ReactNode
} & React.HTMLAttributes<HTMLSpanElement>

/**
 * Hides content visually while keeping it accessible to screen readers.
 * Uses the `sr-only` utility class to remove the element from visual flow.
 */
export default function VisuallyHidden({ children, ...props }: VisuallyHiddenProps) {
  return (
    <span className="sr-only" {...props}>
      {children}
    </span>
  )
}

export { VisuallyHidden }

